import { externalRequest } from "../../helpers/fetching";
import mutations from "../mutations";

export default {
  state: {
    affiliate: {},
    loading: false,
    error: null,
  },
  mutations,
  actions: {
    fetchAffiliate({ commit }, params) {
      return new Promise((resolve) => {

        commit("setState", { key: "loading", value: true });

        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer " + params.token);
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        
        urlencoded.append("eps_id", params.data.eps_id);
        urlencoded.append("numero_documento", params.data.numero_documento);
        urlencoded.append("tipo_documento", params.data.tipo_documento);

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };

        fetch(params.url, requestOptions)
          .then(response => response.text())
          .then(response => {
            console.log(response)
            if(typeof response == "string") {
              try {
                response = JSON.parse(response)
              } catch (error) {
                console.log(error)
              }
            }
            if(typeof response == 'object' && response.beneficiario ){
              response.beneficiario = response.beneficiario.replace(/[^a-z\d\s]+/gi, "");
            }
            commit("setState", { key: "affiliate", value: response });
            commit("setState", { key: "loading", value: false });
            resolve();
          })
          .catch(error => {
            console.log("Error: ")
            console.log(error)
            externalRequest(params)
              .then((response) => {
                if(typeof response == 'object' && response.beneficiario ){
                  response.beneficiario = response.beneficiario.replace(/[^a-z\d\s]+/gi, "");
                }
                if(typeof response == "string") {
                  try {
                    response = JSON.parse(response)
                  } catch (error) {
                    console.log(error)
                  }
                }
                commit("setState", { key: "affiliate", value: response });
                commit("setState", { key: "loading", value: false });
                resolve();
              })
              .catch((error) => {
                console.error(error);
                commit("setState", { key: "error", value: error });
                commit("setState", { key: "loading", value: false });
                resolve();
              });
          });


      });
    },
    resetEnvironment({ commit }) {
      commit("setState", { key: "affiliate", value: {} });
    },
  },
};
